// 主表表头
module.exports = {
  // 视图表名
  viewTableName: '视图表名',
  // 视图表描述
  viewTableDescription: '视图表描述',
  // 原表版本
  originalVersion: '原表版本',
  // 视图版本
  viewVersion: '视图版本',
  // 报表名称
  reportName: '报表名称',
  // 编码
  coding: '编码',
  // 查询SQL
  querySQL: '查询SQL',
  // 数据源
  dataSource: '数据源',
  // 操作
  operate: '操作',
  // 表类型
  tableType: '表类型',
  // 表名
  tableName: '表名',
  // 表描述
  tableDescription: '表描述',
  // 参数
  parameter: '参数',
  // 参数文本
  parameterText: '参数文本',
  // 分组标题
  groupTitle: '分组标题',
  // 取值表达式
  valueExpression: '取值表达式',
  // 查询模式
  queryMode: '查询模式',
  // 是否显示
  isDisplay: '是否显示',
  // 字段文本
  fieldText: '字段文本',
  // 按钮编码
  buttonCode: '按钮编码',
  // 按钮名称
  buttonName: '按钮名称',
  // 按钮样式
  buttonStyle: '按钮样式',
  // 按钮类型
  buttonType: '按钮类型',
  // 按钮图标
  buttonIcon: '按钮图标',
  // 表达式
  expression: '表达式',
  // 按钮状态
  buttonState: '按钮状态',
  fieldName: '字段名称',
  fieldRemark: '字段备注',
  fieldType: '字段类型',
  fieldHref: '字段Href',
  fieldRule: '验证规则',
  fieldCheck: '校验必填',
  fieldDic: '字典Table',
  fieldDicCode: '字典Code',
  fieldDicCodeText: '字典Text',
  defaultValue: '默认值',
  controlType: '控件类型',
  indexName: '索引名称',
  indexField: '索引栏位',
  indexType: '索引类型',
  mainTableName: '主表名',
  mainTableFields: '主表字段',
  primaryKey: '主键',
  allowNulls: '允许空值',
  fieldLength: '字段长度',
  decimalPoint: '小数点',
  formDisplay: '表单显示',
  listDisplay: '列表显示',
  isSort: '是否排序',
  isReadOnly: '是否只读',
  controlLength: '控件长度',
  isSearch: '是否查询',
  searchType: '查询类型',
  controlDefaultValue: '控件默认值',
  extendedParameter: '扩展参数',
  customConverter: '自定义转换器',
  yonghumingcheng: '用户名称',//用户名称
  kucunliang: '库存量', // 库存量
  businessPartners: '业务伙伴', // 业务伙伴
  costItemCode: ' 成本项编号', // 成本项编号
  costItemName: ' 成本项名称', // 成本项名称
  documentNumber: '单据编号', // 单据编号
  periodCode: '期间代码',//期间代码
  demandDate: '需求日期', // 需求日期
  serviceDepartmentOrFarm: '服务部或农场', // 服务部或农场
  documentType: '单据类型', // 单据类型
  requestedArrivalDate: '要求到货日期', // 要求到货日期
  createdBy: '创建人', // 创建人
  updateBy: '修改人', // 修改人
  updateTime: '修改时间', // 修改时间
  documentStatus: '单据状态', // 单据状态
  syncStatus: '同步状态', // 同步状态
  syncMessage: '同步消息', // 同步消息
  operation: '操作', // 操作
  materialCode: '物料编码', // 物料编码
  materialName: '物料名称', // 物料名称
  manufacturer: '厂家', // 厂家
  specification: '规格', // 规格
  job: '职务',//职务
  titleName: '职务名称', // 职务名称
  pleaseEnterTitleName: '请输入职务名称', // 请输入职务名称
  titleCode: '职务编码', // 职务编码
  pleaseEnterTitleCode: '请输入职务编码', // 请输入职务编码
  titleRank: '职务职级', // 职务职级
  pleaseChooseTitleRank: '请选择职务职级', // 请选择职务职级
  unit: '单位', // 单位
  quantity: '数量', // 数量
  arrivalDate: '到货日期', // 到货日期
  remarks: '备注', // 备注
  documentDate: '单据日期', // 单据日期
  sourceInformation: '来源信息', // 来源信息
  batchNumber: '批号', // 批号
  supplierCode: '供应商编码', // 供应商编码
  supplierName: '供应商名称', // 供应商名称
  billingDate: '单据日期', // 单据日期
  billingStatus: '单据类型', // 单据类型
  unitName: '单位名称', // 单位名称
  inboundQuantity: '入库数量', // 入库数量
  productionDate: '生产日期', // 生产日期
  type: '类型', // 类型
  purchaseContractNumber: '采购合同号', // 采购合同号
  farm: '农场', // 农场
  notClearQuantity: '未清数量', // 未清数量
  requestedDateOfShipment: '要求发货日期', // 要求发货日期
  thirdPartySystemCode: '第三方系统编码', // 第三方系统编码
  number: '编号', // 编号
  weight: '重量', // 重量
  postingDate: '过账日期', // 过账日期
  customerCode: '客户编码', // 客户编码
  customerName: '客户名称', // 客户名称
  salesOrderNumber: '销售订单号', // 销售订单号
  operator: '操作人', // 操作人
  billLineNumber: '单据行号', // 单据行号
  salesType: '销售类型', // 销售类型
  averageWeight: '均重(g)', // 均重(g)
  lineNumber: '行号', // 行号
  numberOfOrders: '订单数', // 订单数
  outstanding: '未清数', // 未清数
  warehouse: '仓库', // 仓库
  warehouseLocation: '库位', // 库位
  expirationDate: '有效期', // 有效期
  transferOutFarmServiceDepartment: '转出农场/服务部', // 转出农场/服务部
  transferToFarmService: '转入农场/服务部', // 转入农场/服务部
  materialCodeMaterialNameBatchWarehouseLocation: '物料编码|物料名称|批次|仓库|库位', // 物料编码|物料名称|批次|仓库|库位
  transferOutWarehouse: '转出仓', // 转出仓库
  transferOutWarehousePosition: '转出库位', // 转出库位
  transferToWarehouse: '转入仓', // 转入仓库
  transferToWarehousePosition: '转入库位', // 转入库位
  transferOutWarehouseCode: '转出仓库编码', // 转出仓库编码
  transferOutWarehouseSpaceCode: '转出库位编码', // 转出库位编码
  building: '栋舍', // 栋舍
  feedingLot: '饲养批次', // 饲养批次
  averageEggWeight: '蛋均重（g）', // 蛋均重（g）
  flockName: '批次名称', // 批次名称
  placementAge: '入舍日龄', // 入舍日龄
  generation: '代次', // 代次
  breed: '品种', // 品种
  status: '状态', // 状态
  breedingMethod: '养殖方式', // 养殖方式
  creationTime: '创建时间', // 创建时间
  gender: '性别', // 性别
  roundingNumber: '入舍数', // 入舍数
  NumberOfStock: '存栏数', // 存栏数
  conclusion: '结论', // 结论
  dateOfAcceptance: '验收日期', // 验收日期
  receivingAndInspectionPersonnel: '验收人员', // 验收人员
  warehouseCode: '仓库编码', // 仓库编码
  warehouseName: '仓库名称', // 仓库名称
  roadDamage: '路损', // 路损
  quantityInStock: '库存数量', // 库存数量
  feedingQuantity: '饲喂数量', // 饲喂数量
  feedingMethod: '饲喂方式', // 饲喂方式
  feedingTime: '饲喂时间(分)', // 饲喂时间(分)
  quantityUsed: '用量', // 用量
  applicableScenario: '适用场景', // 适用场景
  genderBeforeConversion: '转换前性别', // 转换前性别
  materialAbbreviation: '物料简称', // 物料简称
  startingAge: '开始日龄', // 开始日龄
  theStartingAgeCannotBeGreaterThanTheEndingAge: '起始日龄不能大于结束日龄', // 起始日龄不能大于结束日龄
  endingAge: '结束日龄', // 结束日龄
  endingAgeCannotBeLessThanStartingAge: '结束日龄不能小于起始日龄', // 结束日龄不能小于起始日龄
  createdTime: '创建时间', // 创建时间
  modifiedBy: '修改人', // 修改人
  modifiedAt: '修改时间', // 修改时间
  harvestMaterial: '出栏物料', // 出栏物料
  fromMaterial: 'from物料', // from物料
  currentStock: '当前存栏', // 当前存栏
  transferOutFarm: '转出农场', // 转出农场
  transferOutOfTheBuilding: '转出栋舍', // 转出栋舍
  transferToFarm: '转入农场', // 转入农场
  stock: '存栏量', // 存栏量
  dayAge: '日龄', // 日龄
  numberOfTransfer: '转出数量', // 转出数量
  numberOfTransfersIn: '转入数量', // 转入数量
  transferOutBatch: '转出批次', // 转出批次
  quantityReceived: '领用数量', // 领用数量
  tibialLength: '胫长(cm)', // 胫长(cm)
  numberOfWeighs: '称重只数', // 称重只数
  version: '版本', // 版本
  startDate: '开始日期', // 开始日期
  endDate: '结束日期', // 结束日期
  dateOfCreation: '创建日期', // 创建日期
  testResult: '检测结果', // 检测结果
  month: '月份', // 月份
  billMaker: '制单人', // 制单人
  numberOfPeopleOnTheRegister: '在册人数', // 在册人数
  numberOfOutsideAssociates: '外协人数', // 外协人数
  code: '编码', // 编码
  name: '名称', // 名称
  shortName: '简称', // 简称
  farmerType: '养户类型', // 养户类型
  whetherTheCompany: '是否公司(Y是N否)', // 是否公司(Y是N否)
  breedingScale: '养殖规模(只）', // 养殖规模(只）
  breederStatus: '养户状态', // 养户状态
  telephone: '电话', // 电话
  contactPerson: '联系人', // 联系人
  affiliatedSupplierCode: '关联供应商编码', // 关联供应商编码
  numberOfDeaths: '死亡数量', // 死亡数量
  culls: '淘汰数量', // 淘汰数量
  sales: '销售数量', // 销售数量
  total: '合计', // 合计
  partnerType: '伙伴类型', // 伙伴类型
  partnerGrouping: '伙伴分组', // 伙伴分组
  enterpriseType: '企业类型', // 企业类型
  country: '国家', // 国家
  province: '省份', // 省份
  cityPrefectureLevelCity: '市/地级市', // 市/地级市
  countyDistrict: '县/区', // 县/区
  legalPerson: '法人', // 法人
  materialGroupCode: '物料组编码', // 物料组编码
  materialGroup: '物料组', // 物料组
  brand: '品牌', // 品牌
  spectrum: '谱系', // 谱系
  stockUnit: '库存单位', // 库存单位
  whetherValid: '是否有效', // 是否有效
  description: '描述', // 描述
  materialGroupClassification: '物料组分类', // 物料组分类
  validity: '有效性', // 有效性
  ERPInventoryLocation: 'ERP库存地点', // ERP库存地点
  warehouseType: '仓储类型', // 仓储类型
  warehouseIdentification: '仓库标识', // 仓库标识
  maximumCapacity: '最大容量(kg)', // 最大容量(kg)
  affiliatedWarehouse: '所属仓库', // 所属仓库
  purchaseUnit: '采购单位', // 采购单位
  salesUnit: '销售单位', // 销售单位
  conversionRate: '换算率', // 换算率
  factoryCode: '工厂编码', // 工厂编码
  batchManagement: '批次管理', // 批次管理
  convertibleMaterialName: '可转换物料名称', // 可转换物料名称
  incubationAgeFrom: '孵化日龄从', // 孵化日龄从
  hatchingAgeTo: '孵化日龄到', // 孵化日龄到
  standardType: '标准类型', // 标准类型
  category: '品类', // 品类
  enabledOrNot: '是否启用', // 是否启用
  enable: '启用', // 启用
  disable: '禁用', // 禁用
  lockedStatus: '锁定状态', // 锁定状态
  normal: '正常', // 正常
  locked: '已锁定', // 已锁定
  defaultVersion: '默认版本', // 默认版本
  weekAge: '周龄', // 周龄
  eggMaterialCode: '蛋品物料号', // 蛋品物料号
  eggMaterialName: '蛋品物料名称', // 蛋品物料名称
  HenFeedNumber: '母禽饲料号', // 母禽饲料号
  henFeedName: '母禽饲料名称', // 母禽饲料名称
  standardGramOfHenFeed: '母禽饲料只耗标准g', // 母禽饲料只耗标准g
  maleFeedNumber: '公禽饲料号', // 公禽饲料号
  maleFeedName: '公鸡饲料名称', // 公鸡饲料名称
  standardGramOfMaleChickenFeed: '公鸡饲料只耗标准g', // 公鸡饲料只耗标准g
  vaccinationPeriod: '免疫周期', // 免疫周期
  startMonth: '开始月份', // 开始月份
  theStartMonthCannotBeGreaterThanTheEndMonth: '开始月份不能大于结束月份', // 开始月份不能大于结束月份
  endMonth: '结束月份', // 结束月份
  theEndMonthCannotBeLessThanTheStartMonth: '结束月份不能小于开始月份', // 结束月份不能小于开始月份
  target: '目标', // 目标
  vaccineName: '疫苗名称', // 疫苗名称
  vaccinationMethod: '接种方式', // 接种方式
  dose: '剂量', // 剂量
  item: '项目', // 项目
  individualMinimum: '个体最小值', // 个体最小值
  individualMinimumCannotBeGreaterThanIndividualMaximum: '个体最小值不能大于个体最大值', // 个体最小值不能大于个体最大值
  individualMaximum: '个体最大值', // 个体最大值
  individualMaximumValueCannotBeLessThanIndividualMinimumValue: '个体最大值不能小于个体最小值', // 个体最大值不能小于个体最小值
  minimumAverage: '最小平均值', // 最小平均值
  theMinimumMeanCannotBeGreaterThanTheMaximumMean: '最小平均值不能大于最大平均值', // 最小平均值不能大于最大平均值
  maximumMean: '最大平均值', // 最大平均值
  theMaximumAverageCannotBeLessThanTheMinimumAverage: '最大平均值不能小于最小平均值', // 最大平均值不能小于最小平均值
  Dispersion: '离散度', // 离散度
  lightDuration: '光照时长', // 光照时长
  minimumLightIntensity: '光照强度最小值', // 光照强度最小值
  maximumLightIntensity: '光照强度最大值', // 光照强度最大值
  temperatureMinimum: '温度最小值', // 温度最小值
  temperatureMaximum: '温度最大值', // 温度最大值
  highTemperatureAlarm: '高温报警', // 高温报警
  lowTemperatureAlarm: '低温报警', // 低温报警
  humidityMinimum: '湿度最小值', // 湿度最小值
  humidityMaximum: '湿度最大值', // 湿度最大值
  carbonDioxide: '二氧化碳', // 二氧化碳
  feedingAmount: '饲喂量(克/只/天)', // 饲喂量(克/只/天)
  livability: '成活率(%)', // 成活率(%)
  bodyWeight: '体重(克)', // 体重(克)
  weeklyEggProductionRate: '周产蛋率(%)', // 周产蛋率(%)
  htatchableEggRate: '种蛋合格率(%)', // 种蛋合格率(%)
  layingRateOfHousedHens: '入舍母禽产蛋率(%)', // 入舍母禽产蛋率(%)
  eggWeight: '蛋重(克)', // 蛋重(克)
  hatchability: '种蛋孵化率(%)', // 种蛋孵化率(%)
  DOCLaidPerWeekByHousedHens: '入舍母禽周产雏数', // 入舍母禽周产雏数
  company: '公司', // 公司
  feedingAmount: '饲喂量/g', // 饲喂量/g
  usage: '用法', // 用法
  grower: '养户', // 养户
  feedNumber: '饲料编号', // 饲料编号
  feedName: '饲料名称', // 饲料名称
  vaccineNumber: '疫苗编号', // 疫苗编号
  vaccineName: '疫苗名称', // 疫苗名称
  drugNumber: '药品编号', // 药品编号
  drugName: '药品名称', // 药品名称
  incubationDate: '上孵日期', // 上孵日期
  poultrySpeciesBatch: '禽种批次', // 禽种批次
  incubationsNumber: '上孵数量', // 上孵数量
  incubator: '孵化器', // 孵化器
  dropDate: '落盘日期', // 落盘日期
  hatchingDate: '出雏日期', // 出雏日期
  operationDate: '操作日期', // 操作日期
  materialCodeBatchWarehouse: '物料编码|批次号|仓库', // 物料编码|批次号|仓库
  hatchery: '孵化场', // 孵化场
  targetWarehouse: '目标仓库', // 目标仓库
  secondaryUOMQuantity: '辅计量数量', // 辅计量数量
  inventoryNumber: '库存数', // 库存数
  targetMaterialCode: '目标物料编码', // 目标物料编码
  targetMaterialname: '目标物料名称', // 目标物料名称
  incubationBatchNumber: '孵化批号', // 孵化批号
  incubationDays: '孵化天数', // 孵化天数
  hatchingNumber: '在孵数', // 在孵数
  hatcher: '出雏器', // 出雏器
  eggByProductCodeBatchNumber: '蛋类副产品编码|批次号', // 蛋类副产品编码|批次号
  byProductDescription: '副产品描述', // 副产品描述
  immuneMode: '免疫方式', // 免疫方式
  dictionaryName: '字典名称', // 字典名称
  dictionaryNumber: '字典编号', // 字典编号
  dataValue: '数据值', // 数据值
  categoryName: '分类名称', // 分类名称
  categoryCode: '分类编码',// 分类编码
  userAccount: '用户账号', // 用户账号
  userName: '用户姓名', // 用户姓名
  image: '头像', //  头像
  birthday: '生日', // 生日
  cellPhone: '手机号码', // 手机号码
  department: '部门', // 部门
  roleCode: '角色编码', // 角色编码
  roleName: '角色名称', // 角色名称
  menuName: '菜单名称', // 菜单名称
  menuType: '菜单类型', // 菜单类型
  icon: '菜单图标',//菜单图标
  frontComponents: '前端组件', // 前端组件
  menuPath: '菜单路径', // 菜单路径
  sort: '排序', // 排序
  ruleName: '规则名称', // 规则名称
  ruleValue: '规则值',// 规则值
  ruleField: '规则字段', // 规则字段
  eRPNumber: 'ERP单号',//ERP单号
  storehouseType: '仓库类型',//仓库类型
  farms: '养殖场', // 养殖场
  applicant: '申请人',//申请人
  contractNo: '合同编号',//合同编号
  numberOfApplications: '申请数量',//申请数量
  theNumberOfShipments: '发货数量',//发货数量
  receiptQuantity: '收货数量',//收货数量
  costPrice: '成本单价',//成本单价
  settlementUnitPrice: '结算单价',//结算单价
  farmingBatch: '养殖批次',//养殖批次
  plannedDateOfSeedling: '计划进苗日期',//计划进苗日期
  pleaseSelectBreedingBatch: '请选择养殖批次',//请选择养殖批次
  growerName: '养户名称',//养户名称
  technician: '技术员', // 技术员
  contractID: '合同号',//合同号
  settlementAmount: '结算金额',//结算金额
  detailPrimaryKey: '明细主键',//明细主键
  contractCode: '合同编码', // 合同编码
  cooperationMode: '合作模式',//合作模式
  dateOfSigning: '签订日期',//签订日期
  effectiveDate: '生效日期', // 生效日期
  auditStatus: '审核状态', // 审核状态
  businessType: '业务类型',//业务类型
  businessItem: '业务项目',//业务项目
  expenseAmount: '费用金额',//费用金额
  auditStatus: '审核状态',//审核状态
  unitPrice: '单价',//单价
  materialCategory: '物料类别',//物料类别
  materialNumber: '物料编号',//物料编号
  materialName: '物料名称',//物料名称
  specification: '规格',//规格
  unit: '单位',//单位
  amount: '金额',//金额
  bookkeepingDate: '记账日期',//记账日期
  contracName: '合同名称',//合同名称
  batchNumber: '批次编号',//批次编号
  batchName: '批次名称',//批次名称
  feedingCycle: '饲养周期',//饲养周期
  plannedNumberOfChicks: '计划入雏数量',//计划入雏数量
  documentNo: '单据编号',//单据编号
  batchNo: '养殖批次',//养殖批次
  qtyRequested: '申请数量',//申请数量
  plannedPlacementDate: '计划进苗日期',//计划进苗日期
  dateOfDemand: '需求日期',//需求日期
  receivedQty: '收货数量',//收货数量
  unitNo: '单位编号',//单位编号
  costUnitPrice: '成本单价',//成本单价
  storageType: '入库类型', // 入库类型
  serviceDepartment: '服务部', // 服务部
  date: '日期',//日期
  chickenPrice: '成鸡价格',// 成鸡价格
  materialCommonName: '物料通用名',//物料通用名
  model: '型号',//型号
  unitOfMeasurement: '计量单位',//计量单位
  validOrNot: '是否有效',//是否有效
  contracts: '合同',//合同
  lastApprovalTime: '最后审批时间',//最后审批时间
  lastApproval: '最后审批人',//最后审批人
  reviewStatus: '审核状态',//审核状态
  securityDepositOperation: '保证金操作',//保证金操作
  businessDate: '业务日期',//业务日期
  operationTime: '操作时间',//操作时间
  batch: '批次',//批次
  batchSize: '批次规模',//批次规模
  placementQty: '入雏数量',//入雏数量
  currentStock: '当前存栏数',//当前存栏数
  reasonForApplication: '申请原因',//申请原因
  dateOfApplication: '申请日期',//申请日期
  applicationType: '申请类型',//申请类型
  totalAmount: '金额合计',//金额合计
  accountDate: '记账日期',//记账日期
  applicationInitiationDate: '申请发起日期',//申请发起日期
  cooperationModel: '合作模式',//合作模式
  partyBDividendRatio: '乙方分红比例',//乙方分红比例
  marketPrice: '市场价格',//市场价格
  exceedingPrice: '超出价格',//超出价格
  stocker: '放养员',//放养员
  stockerInCharge: '放养负责人',//放养负责人
  totalWeight: '出栏总重量',//出栏总重量
  dividendAmount: '分红金额',//分红金额
  accountOfTheBank: '开户行账户', // 开户行账户
  dividendPrice: '分红价格',//分红价格
  contractName: '合同名称',//合同名称
  cooperationMode: '合作模式',//合作模式
  contractType: '合同类型',//合同类型
  dateOfContractSigning: '合同签订日期',//合同签订日期
  contractEffectiveDate: '合同生效日期',//合同生效日期
  contractTerminationDate: '合同终止日期',//合同终止日期
  placeOfSigning: '签订地点',//签订地点
  sector: '部门',//部门
  enteredBy: '录入人',//录入人
  conversionRate: 'Conversion rate',//折本汇率
  fosterCareAdministrator: '养户管理员',//养户管理员
  serviceGroup: '服务组',//服务组
  contractVersion: '合同版本',//合同版本
  breederAdministrator: '养户管理员',//养户管理员
  localCurrency: '本位币',//本位币
  currency: '币种',//币种
  industry: '行业',//行业
  partyB: '乙方养户',//乙方养户
  partyA: '甲方公司',//甲方公司
  applicationInitiationTime: '申请发起时间',//申请发起时间
  mainUnitOfMeasurement: '主计量单位',//主计量单位
  fileCode: '档案编码',//档案编码
  fileDescription: '档案描述',//档案描述
  affiliateCategory: '关联类别',//关联类别
  costItemClassificationCode: '费用项分类编码',//费用项分类编码
  costItemClassification: '费用项分类',//费用项分类
  costItems: '成本项目',//成本项目
  costItemCode: '成本项编码',//成本项目
  costItemName: '成本项名称',//成本项目
  diseaseFileCode: '疾病档案编码',//疾病档案编码
  diseaseCategory: '疾病类别',//疾病类别
  diseaseFileDescription: '疾病档案描述',//疾病档案描述
  associatedDiseaseCategories: '关联疾病类别',//关联疾病类别
  diseaseDescription: '疾病说明',//疾病说明
  symptomProfileCodes: '症状档案编码',//症状档案编码
  symptomProfileName: '症状档案名称',//症状档案名称
  fileType: '档案类型',//档案类型
  symptomFileDescription: '症状档案描述',//症状档案描述
  treatmentPlanName: '治疗方案名称',//治疗方案名称
  treatmentPlanDescription: '治疗方案描述',//治疗方案描述
  organsAnatomyFileCode: '脏器解剖档案编码',//脏器解剖档案编码
  anatomyFileName: '脏器解剖档案名称',//脏器解剖档案名称
  visceralAnatomyFileType: '脏器解剖档案类型',//脏器解剖档案类型
  organDissectionClassification: '脏器解剖分类',//脏器解剖分类
  descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
  inspectionSubcategoryCode: '巡检小类编码',//巡检小类编码
  descriptionOfInspectionSubcategory: '巡检小类描述',//巡检小类描述
  inspectionCategory: '巡检大类',//巡检大类
  inspectionSubCategoryNumber: '巡检小类编号',//巡检小类编号
  nameOfInspectionCategory: '巡检小类名称',//巡检小类名称
  recurringIndicatorFileNumber: '循环指标档案编号',//循环指标档案编号
  circularIndicatorFileName: '循环指标档案名称',//循环指标档案名称
  breedingCategory: '饲养品类',//饲养品类
  feedingStage: '饲养阶段',//饲养阶段
  survivalRate: '成活率',//成活率
  averageWeightOfAdultChickens: '成禽均重',//成鸡均重
  feedingAmount: '喂料量',//喂料量
  realMeatRatio: '真实料肉比',//真实料肉比
  regularRatio: '常规料肉比',//常规料肉比
  serviceCompanyGuaranteePoint: '服务公司保本点',//服务公司保本点
  seedlingPriceToMeatRatio: '种苗价肉比',//种苗价肉比
  feedToMeatRatio: '饲料价肉比',//饲料价肉比
  vaccinePriceToMeatRatio: '疫苗价肉比',//疫苗价肉比
  healthCareMedicinePriceToMeatRatio: '保健药价肉比',//保健药价肉比
  treatmentMedicinePriceToMeatRatio: '治疗药价肉比',//治疗药价肉比
  priceToMeatRatioForPayingFarmers: '支付养户成本价肉比',//支付养户成本价肉比
  fileName: '档案名称',//档案名称
  standardCycleIndicatorNumber: '标准循环指标编号',//标准循环指标编号
  standardCycleIndicatorName: '标准循环指标名称',//标准循环指标名称
  pleaseEnterTheFileName: '请输入档案名称',//请输入档案名称
  chickenInspectionCode: '鸡苗检查编码',//鸡苗检查编码
  descriptionOfChickenInspection: '鸡苗检查描述',//鸡苗检查描述
  addressOnly: '地址', // 地址
  phoneNumber: '电话', // 电话
  symptomCategory: '症状类别',//症状类别
  descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
  associatedDiseaseDescription: '关联疾病说明',//关联疾病说明
  symptomProfile: '症状档案',//症状档案
  symptomName: '症状名称',//症状名称
  symptomDescription: '症状说明',//症状说明
  visceralAnatomyProfile: '脏器解剖档案',//脏器解剖档案
  organAnatomyName: '脏器解剖名称',//脏器解剖名称
  organAnatomyDescription: '脏器解剖说明',//脏器解剖说明
  treatmentPlanFile: '治疗方案档案',//治疗方案档案
  treatmentProtocolName: '治疗方案名称',//治疗方案名称
  treatmentProtocolDescription: '治疗方案说明',//治疗方案说明
  symptomCategory: '症状类别',//症状类别
  symptomProfileDescription: '症状档案描述',//症状档案描述
  treatmentPlanCode: '治疗方案编码',//治疗方案编码
  treatmentPlanDescription: '治疗方案描述',//治疗方案描述
  organsAnatomyCategory: '脏器解剖类别',//脏器解剖类别
  descriptionOfTheOrganAutopsyFile: '脏器解剖档案描述',//脏器解剖档案描述
  planToRelease: '计划出栏',//计划出栏
  averageWeight: '均重', // 均重
  auxiliaryQuantity: '辅助数量',//辅助数量
  building: '栋舍', // 栋舍
  giveaway: '赠品',//赠品
  operator: '操作人', // 操作人
  roundingDate: '入舍日期',//入舍日期
  species: '品种',//品种
  settlementDate: '结算日期',//结算日期
  highestPrice: '最高价',//最高价
  minimumPrice: '最低价',//最低价
  numberOfSlaughtered: '出栏羽数',//出栏羽数
  weightOfSlaughter: '出栏重量(kg)',//出栏重量(kg)
  averagePigeonWeight: '平均羽重(kg/羽)',//平均羽重(kg/羽)
  amountOfRecovery: '回收金额',//回收金额
  placementDate: '进鸡日期',//进鸡日期
  transferOutDepartment: '转出部门',//转出部门
  transferToDepartment: '转入部门',//转入部门
  materialSettlementPrice: '物资结算价格',//物资结算价格
  lastApprover: '最后审批人',//最后审批人
  method: '方式',//方式
  effectiveTime: '生效时间',//生效时间
  category: '品类', // 品类
  productCostAccountCode: '生产成本科目代码', // 生产成本科目代码
  productCostAccountName: '生产成本科目名称', // 生产成本科目名称
  inventoryAccountCode: '库存科目代码', // 库存科目代码
  inventoryAccountName: '库存科目名称', // 库存科目名称
  salesCostAccountCode: '销售成本科目编号', // 销售成本科目编号
  salesCostAccountName: '销售成本科目名称', // 销售成本科目名称
  yonghumingcheng: '用户名称', // 用户名称
  ruleType: '规则类型', // 规则类型
  RuleValueFormat: '规则值格式', // 规则值格式
  fillRule: '填充规则', // 填充规则
  fillChar: '填充字符', // 填充字符
  length: '长度', // 长度
  sex: '性别'// 性别
}